import * as actionTypes from "../actionTypes";

const initialState = {
  poojaData: null,
};

const pooja = (state = initialState, actions) => {
  const { payload, type } = actions;

  switch (type) {

    case actionTypes.SET_POOJA_LIST: {
      return {
        ...state,
        poojaData: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default pooja;
